<div class="question-wrapper col-md-12">
  <div class="question-row" *ngFor="let question of questions; let i=index">
    <div class="form-group col-md-12">
      <div>
        <label class="question-title">{{question.QuestionStr}}</label>
      </div>
      <div *ngIf="question.Type==1">
        <input type="text " (keyup)="changeAnswer(i, $event)" class="special-font" value="{{userAnswers[i].UserAnswerStr}}" />

      </div>
      <div *ngIf="question.Type==2">
          <textarea type="text" (keyup)="changeAnswer(i, $event)" class="special-font" value="{{userAnswers[i].UserAnswerStr}}"></textarea>
  
        </div>

      <div *ngIf="question.Type==3">
        <div class="answer-row" *ngFor="let answer of questionOptions[i]">

          <div>
            <input [checked]="userAnswers[i].UserAnswerStr.indexOf(answer + ',')>-1" type="checkbox" (click)="changeAnswer(i, $event)" value="{{answer}}" />
          </div>
          <div class="answer-txt">
            {{answer}} 
          </div>
        </div>
      </div>
      <div *ngIf="question.Type==4">
        <div class="answer-row" *ngFor="let answer of questionOptions[i]">

          <div>
            <input type="radio" [checked]="userAnswers[i].UserAnswerStr.indexOf(answer)>-1" name="{{i}}" (click)="changeAnswer(i, $event)" value="{{answer}}" />
          </div>
          <div class="answer-txt">
            {{answer}}
          </div>
        </div>
      </div>
      <div *ngIf="question.Type==5" >
        <select (change)="changeAnswer(i, $event)" >
          <option [selected]="userAnswers[i].UserAnswerStr.indexOf(answer)>-1" *ngFor="let answer of questionOptions[i]" value="{{answer}}">
            {{answer}}
          </option>
        </select>

      </div>
      

    </div>
  </div>
</div>